import { Grid, Space } from "../../Layout";
import { Texts, Title, Media } from "../../Object";

const Head = (props) => {
  const gridProps = {
    main: {
      gap: ["48px", "32px"],
      dir: ["column", "row"],
      layout: ["557px 1fr", "100%"],
    },
  };
  
  const type = props.type;
  
  let mediaCheck = false;
  if(type === 'center') {
    mediaCheck = false;
  } else {
    mediaCheck = true;
  }

  return (
    <>
      <Space size={['80px 0 120px', '64px 0 80px']}>
        <div className="l-row--max-left">
          <Grid {...gridProps.main}>
            <Space size={["120px 0 0", "32px 0 0"]}>
              <Title slug={props.slug}></Title>
            </Space>
            {mediaCheck && 
              <Media class="p-page__img--head" src={`page-head/${props.slug}`} alt="Hero media"></Media>
            }
          </Grid>
        </div>
      </Space>
    </>
  );
};

export default Head;
